import { createSlice } from '@reduxjs/toolkit';

export const shiftTemplatesSlice = createSlice({
  name: 'shiftTemplates',
  initialState: {
    list: null,
    active: null,
    isLoading: false,
    templates_for_select: [],
  },
  reducers: {
    setShiftTemplates: (state, action) => {
      state.list = action.payload;
    },
    setActiveShiftTemplate: (state, action) => {
      state.active = action.payload;
    },
    clearActiveShiftTemplate: (state) => {
      state.active = null;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setTemplatesForSelect: (state, action) => {
      state.templates_for_select = action.payload;
    },
  },
});

export const {
  setShiftTemplates,
  setActiveShiftTemplate,
  clearActiveShiftTemplate,
  setLoading,
  setTemplatesForSelect,
} = shiftTemplatesSlice.actions;
